import React, { useEffect, useState, useRef, createElement } from 'react';
export function SplineBackground() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    // Load the spline-viewer script if not already present
    if (!document.querySelector('script[data-spline-viewer]')) {
      const script = document.createElement('script');
      script.type = 'module';
      script.src = 'https://unpkg.com/@splinetool/viewer@1.9.82/build/spline-viewer.js';
      script.setAttribute('data-spline-viewer', 'true');
      document.head.appendChild(script);
    }
    // Wait for the custom element to be registered
    const checkReady = () => {
      if (customElements.get('spline-viewer')) {
        setReady(true);
      } else {
        // Poll until the custom element is defined
        customElements.whenDefined('spline-viewer').then(() => {
          setReady(true);
        }).catch(() => {
          // Fallback: poll manually
          setTimeout(checkReady, 500);
        });
      }
    };
    checkReady();
  }, []);
  useEffect(() => {
    if (!ready || !containerRef.current) return;
    // Clear previous content
    containerRef.current.innerHTML = '';
    const viewer = document.createElement('spline-viewer');
    viewer.setAttribute('url', 'https://prod.spline.design/BKj-yWPywWXFwa3L/scene.splinecode');
    viewer.setAttribute('loading-anim-type', 'none');
    viewer.style.width = '100%';
    viewer.style.height = '100%';
    viewer.style.display = 'block';
    viewer.style.position = 'absolute';
    viewer.style.inset = '0';
    containerRef.current.appendChild(viewer);
  }, [ready]);
  return <div className="absolute inset-0 z-0" style={{
    minHeight: '600px'
  }} data-id="element-331">
      {/* Spline viewer container - needs pointer-events for WebGL init */}
      <div ref={containerRef} className="absolute inset-0" style={{
      opacity: 0.8
    }} data-id="element-332" />
      {/* Transparent overlay to block user interaction with the 3D scene */}
      <div className="absolute inset-0 z-[1]" data-id="element-333" />
    </div>;
}